import React from "react";
import styled from "styled-components";
import { Tooltip } from "@mui/material";

const CardContainer = styled.div`
    border-radius: 8px;
    border: ${(props) =>
        props.$isActive ? "2px solid #463694" : "1px solid #e4e4e4"};
    background: ${(props) => (props.$isActive ? "#F4F2FB" : "#fff")};
    display: flex;
    width: 240px;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
`;

const Title = styled.div`
    color: var(--Secundary-Pure, #181122);
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    .cents {
        font-size: 20px;
        font-weight: 600;
    }
`;

const Subtitle = styled.div`
    color: var(--Secundary-Pure, #181122);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

const ActionButton = styled.button`
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    border: ${(props) => (props.$isContact ? "1px solid #57c4c2" : "none")};
    background: ${(props) =>
        props.$isContact ? "#fff" : props.$isPending ? "#CD8200" : "#57c4c2"};
    color: ${(props) => (props.$isContact ? "#57c4c2" : "#000")};
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    text-transform: uppercase;

    &:hover {
        background: ${(props) =>
            props.$isContact
                ? "#f0f9f9"
                : props.$isPending
                ? "#B57200"
                : "#4ba09b"};
    }

    &:disabled {
        background: #e4e4e4;
        color: #999;
        cursor: not-allowed;
        border: none;
    }

    /* Hover vermelho para assinatura atual (permite cancelamento) */
    &.can-cancel {
        background: #e4e4e4;
        color: #999;
        cursor: pointer;

        &:hover {
            background: #CD0000;
            color: #fff;
            cursor: pointer;
        }
    }
`;

export default function PlanCard({
    title,
    subtitle,
    buttonText,
    buttonTextOnHover,
    onButtonClick,
    disabled,
    isActive,
    tooltipText,
    isPending,
    isContact,
    canCancel,
}) {
    const [isHovering, setIsHovering] = React.useState(false);

    const button = (
        <ActionButton
            onClick={onButtonClick}
            disabled={canCancel ? false : disabled}
            $isPending={isPending}
            $isContact={isContact}
            className={canCancel ? "can-cancel" : ""}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            {canCancel && isHovering ? buttonTextOnHover : buttonText}
        </ActionButton>
    );

    const formatTitle = (title) => {
        // Se o título começa com "R$", formatar os centavos
        if (title.startsWith("R$")) {
            const parts = title.split(",");
            if (parts.length === 2) {
                return (
                    <>
                        {parts[0]}
                        <span className="cents">,{parts[1]}</span>
                    </>
                );
            }
        }
        return title;
    };

    return (
        <CardContainer $isActive={isActive}>
            <Title>{formatTitle(title)}</Title>
            <Subtitle>{subtitle}</Subtitle>
            {tooltipText && disabled ? (
                <Tooltip
                    title={tooltipText}
                    arrow
                    placement="top"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: "#000",
                                color: "#fff",
                                padding: "5px 12px",
                                "& .MuiTooltip-arrow": {
                                    color: "#000",
                                },
                            },
                        },
                    }}
                >
                    <span style={{ width: "100%" }}>{button}</span>
                </Tooltip>
            ) : (
                button
            )}
        </CardContainer>
    );
}
